<template>
  <PanePromise
    id="fsdf3223f"
    ref="PanePromiseREF"
    fit-content
    disabled
  >
    <LayoutBase gap="20">
      <p class="text">
        {{ t('eventsWizard.createdMessage', { title: props.title }) }}
      </p>
      <ButtonBase @click="hideModal">
        {{ t('common.close') }}
      </ButtonBase>
      <ButtonBase
        class="btn default"
        @click="newEvent"
      >
        {{ t('eventsWizard.addMoreReminder') }}
      </ButtonBase>
    </LayoutBase>
  </PanePromise>
</template>

<script setup>
import { ref } from 'vue'
import { LayoutBase } from '@/components/Layouts'
import { ButtonBase, PanePromise } from '@/UI'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  title: {
    type: String,
  },
})

const router = useRouter()

const emit = defineEmits(['newServey'])
const PanePromiseREF = ref()

const open = async () => {
  await PanePromiseREF.value.open()
}

const newEvent = async () => {
  PanePromiseREF.value.close()
  await new Promise((res) => setTimeout(res, 1000))
  emit('newServey')
}

const hideModal = async () => {
  PanePromiseREF.value.close()
  await new Promise((res) => setTimeout(res, 1000))
  router.push('/calendar')
}

defineExpose({
  openModal: open,
})
</script>

<style scoped lang="scss">
.card {
  border-radius: 40px 40px 0px 0px;
  background: #f9fafd;
  border: 1px solid #edeffd;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.05);
}

.text {
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 30px;
  color: #645c56;
}
</style>
